export async function hashEmail(
  email: string | null | undefined
): Promise<string | null> {
  if (!email) return null

  if (
    typeof crypto === 'undefined' ||
    !crypto.subtle ||
    typeof TextEncoder === 'undefined'
  ) {
    return null
  }

  const normalized = email.trim().toLowerCase()
  if (normalized.length === 0) return null

  const encoded = new TextEncoder().encode(normalized)
  const digest = await crypto.subtle.digest('SHA-256', encoded)

  return Array.from(new Uint8Array(digest))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}
